/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<1e60f48cd6f01fd887e550591a473773>>
 * @relayHash 6e7655bfa1679f3aee0e849646870bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8674d5ff1062be1bb8868a3394cdcc36cbc6effec06d42963a069365c46e374b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type unifiedHelpSearchTextboxQuery$variables = Record<PropertyKey, never>;
export type unifiedHelpSearchTextboxQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
    };
  };
};
export type unifiedHelpSearchTextboxQuery = {
  response: unifiedHelpSearchTextboxQuery$data;
  variables: unifiedHelpSearchTextboxQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "unifiedHelpSearchTextboxQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "AuthenticationContext",
          "kind": "LinkedField",
          "name": "me",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              "action": "THROW",
              "path": "me.user"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "me"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "unifiedHelpSearchTextboxQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e7655bfa1679f3aee0e849646870bd0",
    "id": "8674d5ff1062be1bb8868a3394cdcc36cbc6effec06d42963a069365c46e374b",
    "metadata": {},
    "name": "unifiedHelpSearchTextboxQuery",
    "operationKind": "query",
    "text": "query unifiedHelpSearchTextboxQuery {\n  me {\n    user {\n      __typename\n      accountId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c896fe6e18d8ddc80ad6ad5f2824f33";

export default node;
